import { create } from 'zustand'
import type { NavigationState } from '@/types'

interface NavigationActions {
  openMobileMenu: () => void
  closeMobileMenu: () => void
  toggleMobileMenu: () => void
  openDemoModal: () => void
  closeDemoModal: () => void
  openContactModal: () => void
  closeContactModal: () => void
  openSupportModal: () => void
  closeSupportModal: () => void
  openTermsOfServiceModal: () => void
  closeTermsOfServiceModal: () => void
  openDataResidencyModal: () => void
  closeDataResidencyModal: () => void
  openAccessibilityModal: () => void
  closeAccessibilityModal: () => void
  openPartnershipModal: () => void
  closePartnershipModal: () => void
}

type NavigationStore = NavigationState & NavigationActions

export const useNavigationStore = create<NavigationStore>((set) => ({
  isMobileMenuOpen: false,
  isDemoModalOpen: false,
  isContactModalOpen: false,
  isSupportModalOpen: false,
  isTermsOfServiceModalOpen: false,
  isDataResidencyModalOpen: false,
  isAccessibilityModalOpen: false,
  isPartnershipModalOpen: false,

  openMobileMenu: () => set({ isMobileMenuOpen: true }),
  closeMobileMenu: () => set({ isMobileMenuOpen: false }),
  toggleMobileMenu: () => set((state) => ({ isMobileMenuOpen: !state.isMobileMenuOpen })),
  openDemoModal: () => set({ isDemoModalOpen: true }),
  closeDemoModal: () => set({ isDemoModalOpen: false }),
  openContactModal: () => set({ isContactModalOpen: true }),
  closeContactModal: () => set({ isContactModalOpen: false }),
  openSupportModal: () => set({ isSupportModalOpen: true }),
  closeSupportModal: () => set({ isSupportModalOpen: false }),
  openTermsOfServiceModal: () => set({ isTermsOfServiceModalOpen: true }),
  closeTermsOfServiceModal: () => set({ isTermsOfServiceModalOpen: false }),
  openDataResidencyModal: () => set({ isDataResidencyModalOpen: true }),
  closeDataResidencyModal: () => set({ isDataResidencyModalOpen: false }),
  openAccessibilityModal: () => set({ isAccessibilityModalOpen: true }),
  closeAccessibilityModal: () => set({ isAccessibilityModalOpen: false }),
  openPartnershipModal: () => set({ isPartnershipModalOpen: true }),
  closePartnershipModal: () => set({ isPartnershipModalOpen: false })
}))


